// ----------------------------------------------------------------------------
// Section: Feature Panel
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Pagination, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_how-to-measure.scss';


// -------------------------------------
// Hooks
// -------------------------------------
function handleFeaturePanelSlides(swiperEl) {
    swiperEl.slides.forEach(function (slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function (e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function () {
    $(".carousel--how-to-measure").each(function (index, element) {
        var $this = $(this);
        const desktopSlidesPerView = $this.attr("data-slide");

        if( desktopSlidesPerView < 2 ) {
            desktopSlidesPerView = 2;
        }

        // Generate unique class for each feature card slider
        $this.addClass("how-to-measure-instance-" + index);

        // Initialize feature card slider based on the unique classes generated above.
        var swiper = new Swiper(".how-to-measure-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, A11y, Keyboard],
            slidesPerView: 1.2,
            spaceBetween: 36,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            centerInsufficientSlides: false,
            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: 3.2
                },
                 // when window width is >= 1024px
                1024: {
                    slidesPerView: desktopSlidesPerView
                }
            },
        });

        swiper.slides.forEach(function (slide, index) {
            slide.addEventListener('focus', function (e) {
                swiper.slideTo(index);
            })
        });
    });
});